import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
    <footer>
       
    </footer>
);

export default Footer;